export enum AccountType {
    Business = "Business",
    Personal = "Personal"
}
